import SelectWithStartIconCode from "!!raw-loader!./select/SelectWithStartIcon.tsx";
import SelectColorCode from "!!raw-loader!./select/SingleColorSelect.tsx";
import SelectCode from "!!raw-loader!./select/SingleSelect.tsx";
import ControlledSelectCode from "!!raw-loader!./select/ControlledSelect.tsx";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import SelectWithStartIcon from "./select/SelectWithStartIcon";
import SelectColor from "./select/SingleColorSelect";
import Select from "./select/SingleSelect";
import ControlledSelect from "./select/ControlledSelect";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("Overflow", SelectCode, Select),
		paneComponent("Start Icon", SelectWithStartIconCode, SelectWithStartIcon),
		paneComponent("Controlled Select", ControlledSelectCode, ControlledSelect),
		paneComponent("Color Select", SelectColorCode, SelectColor),
	];

	return (
		<Pane
			components={components}
			imports={"import {Select} from \"designSystem/index\";"}
			muiApi="text-field"
			muiComponent="text-fields"
			{...props}
		/>
	);
};